import { Paper, Stack } from "@mui/material";
import { useRef } from "react";

import { useGetBuildingESGInfo } from "../../api/hooks/allHooks";
import { buildingUsageConfig, buildingUseTypesConfigESGBased } from "../../configs/BuildingProfile";
import { isNumeric } from "../../utils/dataManipulation";
import { CaptureComponent } from "../CaptureComponent";
import { GeneralChartLegend } from "../chart/GeneralChartLegend";
import { HorizontalStackedBarChartColorBar } from "../chart/HorizontalStackedBarChartColorBar";
import { LoadingOrEmptyWrapper } from "../LoadingAndEmptyHandler";

export const UseTypesHorizontal = ({ className, hasCapture, projectId }) => {
  let { data, isLoading } = useGetBuildingESGInfo(projectId);

  const vacantAreaRatio = (data?.vacant ?? 0) / 100;
  const vacancyChartData = [
    {
      label: "Rented",
      percentage: 1 - vacantAreaRatio,
    },
    {
      label: "Vacant",
      percentage: vacantAreaRatio,
    },
  ];
  const vacancyChartLegends = vacancyChartData?.map((row) => {
    return {
      ...row,
      color: buildingUsageConfig[row.label]?.color,
      percentage: row.percentage?.toFixed(1),
    };
  });

  const spatialInformation = data?.spatial_information ?? {};
  const allUseTypes = Object.keys(buildingUseTypesConfigESGBased);
  const activeUseTypes = Object.keys(spatialInformation ?? {}).filter(
    (useType) => allUseTypes.includes(useType) && spatialInformation[useType]
  );

  const dataForUseTypeChart = activeUseTypes.map((useType) => {
    return {
      color: buildingUseTypesConfigESGBased[useType]?.color,
      label: buildingUseTypesConfigESGBased[useType]?.label,
      percentage: spatialInformation[useType] / 100,
    };
  });

  const useTypesChartLegends = dataForUseTypeChart?.map((useType) => {
    return { color: useType?.color, label: useType.label };
  });

  const containerRef = useRef();

  const isVacancyDataNull = !isNumeric(data?.vacant) && !isNumeric(data?.rented);
  const isUsageTypesNull = !Object.keys(spatialInformation ?? {})?.length;
  return (
    <Paper className={className}>
      <div ref={containerRef}>
        <Stack className="justify-between">
          <h3 className="font-ds-headline-lg">Spatial Information</h3>
          {hasCapture && <CaptureComponent targetElement={() => containerRef.current} />}
        </Stack>
        <LoadingOrEmptyWrapper showEmpty={isUsageTypesNull && isVacancyDataNull} showLoading={isLoading}>
          <Stack className="mt-8 w-full  flex-col">
            <div className="w-full">
              <HorizontalStackedBarChartColorBar
                bottom="-30px"
                config={buildingUseTypesConfigESGBased}
                data={dataForUseTypeChart}
                hoverEffect={false}
              />
              <GeneralChartLegend
                className="mt-3  max-h-[60px] w-full overflow-auto pb-2 pt-0"
                legends={useTypesChartLegends}
                showValue
              />
            </div>
            {!isVacancyDataNull && (
              <div className="mt-4 w-full">
                <div className={`relative w-full `}>
                  <Stack className={`absolute bottom-0 h-full w-full flex-col `}>
                    <HorizontalStackedBarChartColorBar
                      bottom="-30px"
                      className="w-full"
                      config={buildingUsageConfig}
                      data={vacancyChartData}
                      hoverEffect={false}
                    />
                  </Stack>
                </div>
                <GeneralChartLegend className="mt-10" legends={vacancyChartLegends} />
              </div>
            )}
          </Stack>
        </LoadingOrEmptyWrapper>
      </div>
    </Paper>
  );
};
